import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective} from '@angular/forms';
import { State, Country, County } from '@app/_models/signups/geography';
import { TooltipMessageService } from '@app/_services/toolservice.service';

@Component({
  selector: 'app-addresscurrent',
  templateUrl: './addresscurrent.component.html',
  styleUrls: ['addresscurrent.component.less']
})
export class AddresscurrentComponent implements OnInit {
  
  @Output() zipCodeChange: EventEmitter<string> = new EventEmitter();
  @Input() states: State[];
  @Input() countries: Country[];
  @Input() counties: County[];
  @Input() selectedState: string;
  @Input() selectedCounty: string;
  @Input() currentAddress: UntypedFormGroup;
  addressTooltip: string;
  addressLine1Invalid: boolean;
  zipInvalid: boolean;
  stateInvalid: boolean;
  cityInvalid: boolean;


  constructor(private tooltipMessenger: TooltipMessageService) {}

  ngOnInit(): void {
    this.addressLine1Invalid = false;
    this.zipInvalid = false;
    this.stateInvalid = false;
    this.cityInvalid = false;
  
    this.tooltipMessenger.currentAddressTooltip.subscribe(addressTooltip => {
      this.addressTooltip = addressTooltip
    });
  }

  handleZipCodeChange(event: any) {
    if (event.srcElement.value != '') {
      this.zipCodeChange.emit(event.target.value);
    }
  }

  showValidation(field: string){
    if(this.currentAddress.controls[field].invalid){
        this[field+"Invalid"] = true;
    }
    else{
        this[field+"Invalid"] = false;
    }
}
}
